// extracted by mini-css-extract-plugin
export var divider = "_qv-0";
export var systemMessage = "_qv-1";
export var systemMessageWrapper = "_qv-2";